import React from 'react';
import { PLAN_SKELETON_IMAGES } from '../../data/featuredCityPreviews';
import { SkeletonText, SkeletonValue } from './SkeletonValue';

const cardBorder = 'border-[rgba(74,33,71,0.1)]';

const PlanDetailSkeleton: React.FC = () => {
  return (
    <div
      className="mx-auto max-w-xl"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Cargando plan"
    >
      <article className={`overflow-hidden rounded-3xl border ${cardBorder} bg-white`}>
        <div className="relative aspect-[16/10] w-full shrink-0 bg-[#ebe4ea]">
          <img
            src={PLAN_SKELETON_IMAGES[0]}
            alt=""
            loading="eager"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover opacity-90"
          />
        </div>

        <div className="p-5 sm:p-6">
          <header className="space-y-2">
            <SkeletonText className="h-7 w-[90%] sm:h-8" />
            <SkeletonText className="h-4 w-48" />
          </header>

          <div className={`mt-4 overflow-hidden rounded-2xl border ${cardBorder} bg-chisme-bg sm:mt-5`}>
            <div className="grid grid-cols-2 gap-0 border-b border-[rgba(74,33,71,0.1)]">
              <div className="border-r border-[rgba(74,33,71,0.1)] px-3 py-3 sm:px-4 sm:py-3.5">
                <SkeletonText className="h-3 w-12" />
                <SkeletonText className="mt-2 h-4 w-24" />
              </div>
              <div className="px-3 py-3 sm:px-4 sm:py-3.5">
                <SkeletonText className="h-3 w-16" />
                <SkeletonValue className="mt-2 h-4 w-8" />
              </div>
            </div>
            <div className="px-3 py-3 sm:px-4 sm:py-3.5">
              <SkeletonText className="h-3 w-14" />
              <SkeletonText className="mt-2 h-4 w-[70%]" />
            </div>
          </div>

          <div className="mt-6 h-[52px] rounded-full bg-[#ebe4ea]" />
        </div>
      </article>
      <span className="sr-only">Cargando plan…</span>
    </div>
  );
};

export default PlanDetailSkeleton;
